import { fetchGetters } from '@/store/extensions/fetch';
import { createGetters } from '@/store/extensions/create';
import { updateGetters } from '@/store/extensions/update';
import { deleteGetters } from '@/store/extensions/delete';

export default {
  ...fetchGetters,
  ...createGetters,
  ...updateGetters,
  ...deleteGetters,

  updating: state => state.updating,
  formModalOpened: state => state.formModalOpened,
  formModalContext: state => state.formModalContext,
};



// WEBPACK FOOTER //
// ./src/store/modules/ptoAvailability/getters.js